import { render, staticRenderFns } from "./phone-number.vue?vue&type=template&id=60de4acf&scoped=true&"
import script from "./phone-number.vue?vue&type=script&lang=js&"
export * from "./phone-number.vue?vue&type=script&lang=js&"
import style0 from "./phone-number.vue?vue&type=style&index=0&id=60de4acf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de4acf",
  null
  
)

export default component.exports